import React, { forwardRef } from 'react';
import Icon, { generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
const draw16px = 'm13.537 3.522-10.03 10.03a.748.748 0 0 1-1.06 0 .754.754 0 0 1 0-1.06l10.03-10.03a.75.75 0 1 1 1.06 1.06Zm.24 7.85a2.4 2.4 0 1 1-2.39-2.39 2.4 2.4 0 0 1 2.39 2.39Zm-1.5 0a.9.9 0 1 0-.89.89.892.892 0 0 0 .89-.89Zm-10.04-6.72a2.43 2.43 0 1 1 2.43 2.43 2.424 2.424 0 0 1-2.43-2.43Zm1.5 0a.93.93 0 1 0 .93-.92.935.935 0 0 0-.93.92Z';
const draw24px = 'M6.7,10.07a3.42,3.42,0,1,1,3.42-3.42A3.43,3.43,0,0,1,6.7,10.07Zm0-5.34A1.92,1.92,0,1,0,8.62,6.65,1.93,1.93,0,0,0,6.7,4.73Zm10.71,16a3.37,3.37,0,1,1,3.36-3.37A3.37,3.37,0,0,1,17.41,20.73Zm0-5.24a1.87,1.87,0,1,0,1.86,1.87A1.87,1.87,0,0,0,17.41,15.49Zm-12.88,5,16-16a.75.75,0,1,0-1.06-1.06l-16,16a.75.75,0,0,0,0,1.06.75.75,0,0,0,1.06,0Z';
const icons = {
  _16: {
    d: draw16px,
    viewBox: VIEWBOXES._16
  },
  _24: {
    d: draw24px,
    viewBox: VIEWBOXES._24
  }
};
const PercentIcon = /*#__PURE__*/forwardRef(generateRenderedIcon(icons, 'percent'));
PercentIcon.displayName = 'PercentIcon';
PercentIcon.propTypes = Icon.propTypes;
PercentIcon.renderIcon = props => /*#__PURE__*/React.createElement(PercentIcon, props);
export default PercentIcon;
//# sourceMappingURL=PercentIcon.js.map